import RevenuePage, { revenueQuery } from "@app/pages/revenue/revenue-page";
import type { revenuePage_Query } from "@app/queries/revenuePage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/revenue")({
  // Optional deep-link from /budgets: ?budget=<gid> loads that budget in planned mode.
  validateSearch: (search: Record<string, unknown>): { budget?: string } => ({
    budget: typeof search.budget === "string" ? search.budget : undefined,
  }),
  // Page-owned year (defaults to the current year server-side); exempt from the
  // global date-range lens, like the categorization overview.
  loader: () =>
    loadQuery<revenuePage_Query>(
      environment,
      revenueQuery,
      {},
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Revenue"),
  component: RevenueRoute,
});

function RevenueRoute() {
  const queryRef = Route.useLoaderData();
  const { budget } = Route.useSearch();

  return (
    <ErrorBoundary fallback={<div className="p-6 text-red-500">Error loading revenue</div>}>
      <Suspense fallback={<div className="p-6 text-gray-500">Loading revenue…</div>}>
        <RevenuePage queryRef={queryRef} initialBudgetId={budget ?? null} />
      </Suspense>
    </ErrorBoundary>
  );
}
